// extracted by mini-css-extract-plugin
export default {"container":"Page_container__ol1Xn"};